import { connect } from 'react-redux';
import { globalKey } from 'data/sharedKeys';
import { loadAccount, saveAccount, postAccountReset } from 'data/accounts/accounts.actions';
import HeroBannerContainer from './HeroBannerContainer';

const key = globalKey;
const actions = {
  loadAccount: () => loadAccount(key),
  saveAccount: account => saveAccount(account, key),
  postAccountReset: () => postAccountReset(key)
};

function mapStateToProps(state) {
  return {
    ...state.accounts[key]
  };
}

export default connect(mapStateToProps, actions)(HeroBannerContainer);
